import { useMemo } from "react";

import { isNoTouch } from "app/UtilitiesAndConstants/UtilityFunctions/trialUsersUtils";

import { shouldShowLowCreditsBanner } from "../utils/quotaCalculations";

type HookParams = {
    totalQuota: number;
    remainingQuota: number;
    pricePerRecord?: number;
    maxOptionValue?: number;
};

export const useLowCreditsBannerVisibility = (params: HookParams): boolean => {
    const { totalQuota, remainingQuota, pricePerRecord, maxOptionValue } = params;

    return useMemo(() => {
        return shouldShowLowCreditsBanner({
            totalQuota,
            remainingQuota,
            pricePerRecord,
            maxOptionValue,
            isNoTouchUser: isNoTouch(),
        });
    }, [totalQuota, remainingQuota, pricePerRecord, maxOptionValue]);
};
